module.exports = __webpack_public_path__ + "img/mark.afaf014d.svg";